import useModal from 'hooks/useModal';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BillDetailNoBill, Header, Main, Modal } from './components';
import { BillTypes } from 'models';
import { useAppDispatch, useAppSelector } from 'hooks';
import { shopAction } from 'redux/slices/shopSlice';
import { getBillTableAPI } from 'redux/api';
import { settingsAction } from 'redux/slices/settingsSlice';
import { DEFAULT_APP_NAME } from '../../constants';

const HomePage = () => {
  const router = useLocation();
  const dispatch = useAppDispatch();
  const billInfo: BillTypes = useAppSelector((state) => state.bill.billInfo);
  const shop_id = router.search?.split('=')[1].split('&')[0];
  const table_id = router.search?.split('=')[2];
  const { isShowing, toggle } = useModal();
  const [billList, setBillList] = useState<BillTypes[]>([]);
  const [billDetail, setBillDetail] = useState<BillTypes>({} as BillTypes);
  const [billDetailNoBill, setBillDetailNoBill] = useState<BillTypes>({} as BillTypes);
  const [billDetailLoading, setBillDetailLoading] = useState<boolean>(true);
  const getBillTableAPIDetail = useCallback(async () => {
    try {
      const res = await getBillTableAPI({ shop_id, table_id, appName: DEFAULT_APP_NAME });
      setBillDetailLoading(false);
      if (Array.isArray(res.data)) {
        if (billInfo.id) {
          setBillList(res.data.filter((item) => item.id == billInfo.id));
        } else {
          setBillList(res.data);
        }
      } else {
        setBillDetailNoBill(res.data);
      }
    } catch (error) {
      console.log('error', error);
    }
  }, [shop_id, table_id]);
  useEffect(() => {
    getBillTableAPIDetail();
    dispatch(
      shopAction.getShopInfo({
        shop_id,
        appName: DEFAULT_APP_NAME,
      })
    );
    return () => {};
  }, []);
  const handleSetBillDetail = (data: BillTypes) => {
    setBillDetail(data);
  };
  useEffect(() => {
    // 31/10/2025, remove token order
    if (shop_id) {
      dispatch(
        settingsAction.getSettingsShopCustom({
          shop_id,
          bill_id: billInfo.id,
          appName: DEFAULT_APP_NAME,
        })
      );
    }
  }, [shop_id, dispatch, billInfo.id]);

  return (
    <div className="relative flex flex-col h-screen">
      {billList.length && !billDetailLoading ? (
        billList.map((item) => (
          <div key={item.id} className="mb-4">
            <Header billData={item} show={toggle} onBill={handleSetBillDetail} />
            <Main billData={item} billLoading={billDetailLoading} />
          </div>
        ))
      ) : billDetailLoading ? (
        <></>
      ) : (
        <div className="mb-4">
          <Header billData={billDetailNoBill} show={toggle} onBill={handleSetBillDetail} />
          <BillDetailNoBill billData={billDetailNoBill} />
        </div>
      )}
      {/* {billList.map((item) => (
        <div key={item.id} className="mb-4">
          <Header billData={item} show={toggle} onBill={handleSetBillDetail} />
          <Main billData={item} billLoading={billDetailLoading} />
        </div>
      ))} */}
      <Modal isShowing={isShowing} hide={toggle} data={billDetail} />
    </div>
  );
};

export default HomePage;
